import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelegationSliderComponent } from './delegation-slider/delegation-slider.component';
import { DelegationCreationComponent } from './delegation-creation/delegation-creation.component';
import { DelegationLinkedItemsComponent } from './delegation-linked-items/delegation-linked-items.component';
import { DelegationLinkedItemsPanelListComponent } from './delegation-linked-items-panel-list/delegation-linked-items-panel-list.component';
import { SharedModule } from '../shared/shared.module';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldsetModule } from 'primeng/fieldset';
import { DocumentSearchModule } from '../document-search/document-search.module';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [
    DelegationCreationComponent,
    DelegationSliderComponent,
    DelegationLinkedItemsComponent,
    DelegationLinkedItemsPanelListComponent

  ],
  imports: [
    CommonModule,
    SharedModule,
    TabViewModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    BptProgressSpinnerModule,    
    MessageModule,
    MessagesModule,    
    BptDateTimeModule,
    BptDropdownModule,
    ReactiveFormsModule,
    FieldsetModule,
    DocumentSearchModule,
    DialogModule
  ],
  exports: [
    DelegationSliderComponent
  ],
  providers: [ConfirmationService],

})
export class DelegateSliderModule { }

